import { useState, useEffect, useMemo } from "react";
import {
  // BrowserRouter as Router,
  Routes,
  Route,
  // Navigate,
} from "react-router-dom";

import PrivateRoute from "./authentication/PrivateRoute";
import { AuthRouteData } from "./AuthenticatedRouteData";
import { useSelector } from "react-redux";
// import PageNotFound from "./components/commonComponents/PageNotFound";
import { API } from "./helpers/API/amplifyApi";
import { Auth } from "./authentication/amplifyAuth";
// import LoaderComponent from "./components/commonComponents/LoadableComp/LoadableComp";
import { useAuth } from "./authentication/authHelpers";
import { useDispatch } from "react-redux";
import {
  departments,
  programFields,
  employees,
  clockings,
  setMyClockings,
  users,
  employeeRequests as employeeRequestsAction,
  problematikat,
  shifts as shiftsAction,
} from "./store/actions";
import {
  requestData,
  requestDataWithParams,
} from "./helpers/API/RequestFactory";
import { mapPool } from "./helpers/API/mapPool";
import ResetPassword from "./components/Auth/ResetPassword";
import { useUserSession } from "./hooks/useUserSession";
import { useLocation, matchPath } from "react-router";
import { useActive } from "./hooks/useActive";
import { useTabNotification } from "./hooks/useTabNotification";
import {
  subscribe,
  setSocketIdentity,
  closeDashboardSocket,
} from "./utils/socket/dashboardSocket";
import { showBrowserNotification } from "./utils/browserNotifications";
import {
  isSupportNotificationDuplicate,
  mapClockEventToNotification,
  mapTicketEventToNotification,
} from "./utils/notificationMapping";
import { detectLocalIp } from "./utils/localIp";
import { currentDeviceKind } from "./utils/devicePolicy";
import { deviceType as reactDeviceType } from "react-device-detect";
import { addClocking, editClocking } from "./store/actions/addClockings";
import dayjsTZ from "./utils/dayjs";
import AuthInterface from "./components/Auth/AuthInterface";
import NotFound from "./components/commonComponents/NotFound/NotFound";
import {
  ensureRouteAccess,
  findBestRouteMatch,
} from "./components/Sidebar/ensureRouteAccess";
import { message } from "antd";
import { store } from "./store/store";
import { shouldSuppressSupportNotification } from "./components/Problematikat/SupportInbox/utils/supportFocus";
import {
  isBranchManager,
  isElevatedRole,
  getManagedTeam,
  filterEmployeesByTeam,
  filterClockingsByEmployeeIds,
  employeesTeamFilter,
} from "./utils/branchScope";

function surfaceMappedOsNotification(mapped) {
  if (!mapped) return;
  message.info({
    content: mapped.message
      ? `${mapped.title}: ${mapped.message}`
      : mapped.title,
    duration: 4,
  });
  showBrowserNotification({
    title: mapped.title,
    message: mapped.message,
    url: mapped.url,
    tag: mapped.tag,
  });
}

function AuthenticatedRoute() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  let path = location?.pathname;
  const auth = useAuth();
  const active = useActive(888000);
  // const [isIdle, setIsIdle] = useState(
  //   JSON.parse(window.localStorage.getItem("isIdle")) || false
  // );
  const { employeeRequests } = useSelector((state) => state.employeeRequests);
  // const [userDBInfo, setUserDBInfo] = useState({});
  const [setTabMessage, setIcon, clearTabMessage] = useTabNotification(500);
  const dispatch = useDispatch();
  const userSession = useUserSession();
  // * @EneaXharau - Added a state to set notification count used on tab notifications
  const [countRequestNotif, setCountRequestNotif] = useState(1);
  const clockingsSel = useSelector((state) => state.clockings);
  // const handleOnIdle = () => {
  //   auth?.user !== null && setIsIdle(true);
  //   start();
  // };

  // const { start } = useIdleTimer({
  //   timeout: userDBInfo?.idleTime || 600000,
  //   onIdle: handleOnIdle,
  //   debounce: 1500,
  // });

  // useEffect(() => {
  //   window.localStorage.setItem("isIdle", isIdle);
  // }, [isIdle]);

  useEffect(() => {
    if (!!Object.keys(auth)?.length && !!auth?.userAccess?.length) {
      setLoading(false);
    }
  }, [auth]);

  const isCurrentUserAdmin = useMemo(() => {
    return isElevatedRole(auth?.userRole);
  }, [auth]);

  const updateLogin = async () => {
    let getItem = localStorage.getItem("isActive");
    if (
      !getItem ||
      dayjsTZ().diff(dayjsTZ(parseInt(getItem)), "minutes", true) > 14
    ) {
      await API.put("users", `/users/${auth?.userAccess[0]?.identityId}`, {
        body: { lastLoggedIn: dayjsTZ().valueOf() },
      }).then(() => {
        // setTimeout(() => {
        // 	if (socketHandler.readyState === socketHandler.OPEN) {
        // 		let temp = auth?.userAccess[0];
        // 		delete temp["allUsers"];
        // 		socketHandler.send(
        // 			JSON.stringify({
        // 				request: "user_loggedIn",
        // 				body: temp,
        // 				id: auth?.employeeId,
        // 			})
        // 		);
        // 	}
        // }, 700);
        localStorage.setItem("isActive", dayjsTZ().valueOf());
      });
    }
  };

  useEffect(() => {
    if (
      !!Object.keys(auth)?.length &&
      !!auth?.userAccess?.[0]?.identityId &&
      loading === false
    ) {
      updateLogin();

      // sendDontForget();
    }
  }, [active, auth]);

  useEffect(() => {
    const getData = async () => {
      let monthInterval = dayjsTZ()
        .startOf("month")
        .subtract(1, "months")
        .valueOf();

      const branchManager = isBranchManager(auth);
      const managedTeam =
        getManagedTeam(auth) || auth?.employee?.employeeTeam || null;

      let subObj =
        auth?.userRole === "Employee"
          ? { filterKey: "userSub", filterValue: auth?.user?.userSub }
          : branchManager && managedTeam
            ? employeesTeamFilter(managedTeam)
            : false;

      const ticketsFilterObj =
        auth?.userRole === "Employee"
          ? { filterKey: "employeeId", filterValue: auth?.employeeId }
          : false;

      const attachResolvedTicket = (resp) => {
        for (let i = 0; i < resp.length; i++) {
          const ticket = resp[i];
          if (ticket.ticketStatus === "Completed") {
            ticket.resolvedTicket = dayjsTZ(
              ticket.lastMessageAt || ticket.createdAt
            ).format("DD/MM/YYYY");
            continue;
          }
          const logs = Array.isArray(ticket.ticketLogs)
            ? ticket.ticketLogs
            : [];
          ticket.resolvedTicket = null;
          for (const entry of logs) {
            // Support both flat log entries and legacy nested arrays.
            const flat = Array.isArray(entry) ? entry : [entry];
            for (const log of flat) {
              if (
                log?.field === "ticketStatus" &&
                (log.currentData === "Completed" ||
                  log.newValue === "Completed")
              ) {
                ticket.resolvedTicket = dayjsTZ(log.changeDate).format(
                  "DD/MM/YYYY"
                );
              }
            }
          }
        }
        return resp;
      };

      // Split clockings:
      //  1) myClockings — signed-in employee only → unlocks Veprime Turni fast
      //  2) clockings — company-wide for admins (dashboard stats/widgets)
      // Personal fetch runs outside the pool so it is not stuck behind bulk work.
      const loadMyClockings = (async () => {
        if (!auth?.employeeId) {
          dispatch(setMyClockings([], null));
          if (auth?.userRole === "Employee") {
            dispatch(clockings([]));
          }
          return;
        }
        try {
          const res = await requestDataWithParams(
            "clocking",
            monthInterval,
            null,
            { employeeId: auth.employeeId }
          );
          dispatch(setMyClockings(res || [], auth.employeeId));
          // Employees only need one list — reuse personal rows for Redux clockings.
          if (auth?.userRole === "Employee") {
            dispatch(clockings(res || []));
          }
        } catch (err) {
          console.error("bootstrap myClockings failed", err);
          dispatch(setMyClockings([], auth.employeeId));
          if (auth?.userRole === "Employee") {
            dispatch(clockings([]));
          }
        }
      })();

      // EU sandbox account Lambda concurrency is low (quota 10 until AWS
      // approves increase). Cap parallel API fan-out so login doesn't 500.
      const tasks = [
        async () => {
          // Shift definitions — needed by Veprime Turni; keep early in the pool.
          const res = await API.get("shifts", "/shifts");
          dispatch(shiftsAction(Array.isArray(res) ? res : []));
        },
        async () => {
          const res = await requestData("programFields");
          dispatch(programFields(res));
        },
        async () => {
          const res = await requestDataWithParams(
            "employees",
            null,
            null,
            subObj
          );
          dispatch(employees(res, "GET_ACTIVE_EMPLOYEES"));
        },
        async () => {
          const res = await requestData("users");
          dispatch(users(res));
        },
        async () => {
          // Dashboard bootstrap: last 6 months. Planer / Pushimet re-fetch
          // a wider window on those routes when needed.
          const res = await requestDataWithParams(
            "employeeRequests",
            dayjsTZ().subtract(6, "months").valueOf(),
            null,
            subObj
          );
          dispatch(employeeRequestsAction(res || []));
        },
        async () => {
          const res = await requestDataWithParams(
            "tickets",
            null,
            null,
            ticketsFilterObj
          );
          dispatch(problematikat(attachResolvedTicket(res || [])));
        },
      ];

      // Admin / Supervisor: company-wide clockings for stats cards (separate from Veprime Turni).
      if (auth?.userRole !== "Employee") {
        tasks.push(async () => {
          const res = await requestDataWithParams(
            "clocking",
            monthInterval,
            null,
            false
          );
          dispatch(clockings(res || []));
        });
      }

      if (isCurrentUserAdmin) {
        // Payroll / interviews are loaded on Pagat / Reports / Recruit routes
        // (see ensureDeferredTables) — not at login.
        tasks.push(async () => {
          const res = await requestData("departments");
          dispatch(departments(res));
        });
      }

      await Promise.all([
        loadMyClockings,
        mapPool(tasks, 3, (task) =>
          task().catch((err) => console.error("bootstrap fetch failed", err))
        ),
      ]);

      // Branch Manager: hard-scope Redux to managedTeam (API filter + client safety).
      // Fallback to linked employee.employeeTeam when users.managedTeam is unset
      // (e.g. remapped EU identity without a seeded managedTeam yet).
      const scopeTeam =
        managedTeam ||
        getManagedTeam(auth) ||
        auth?.employee?.employeeTeam ||
        null;
      if (branchManager && scopeTeam) {
        const state = store.getState();
        const scopedEmps = filterEmployeesByTeam(
          state.employeesList?.employees || [],
          scopeTeam,
        );
        dispatch(employees(scopedEmps, "GET_ACTIVE_EMPLOYEES"));
        const ids = new Set(scopedEmps.map((e) => e.employeeId));
        const scopedSubs = new Set(
          scopedEmps.map((e) => e.userSub).filter(Boolean),
        );
        dispatch(
          clockings(
            filterClockingsByEmployeeIds(
              state.clockings?.clockings || [],
              ids,
            ),
          ),
        );
        const reqs = state.employeeRequests?.employeeRequests || [];
        dispatch(
          employeeRequestsAction(
            reqs.filter((r) => {
              if (r?.employeeDetails?.employeeId && ids.has(r.employeeDetails.employeeId)) {
                return true;
              }
              if (r?.userSub && scopedSubs.has(r.userSub)) return true;
              return false;
            }),
          ),
        );
      }
    };
    if (!!auth?.userRole && loading === false) {
      getData();
    }
  }, [auth]);

  // no need since no idle time
  // useEffect(() => {
  //   Auth.currentCredentials().then((r) => {
  //     try {
  //       API.get("users", `/users`).then((users) => {
  //         setUserDBInfo(users);
  //       });
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   });
  // }, []);

  /**
   * * @EneaXharau - Async function taking no parameters
   * * it awaits for redux to fetch data from AWS database
   * * then sets in redux store to update info from database
   */
  const getData = async () => {
    try {
      const loaders = [
        ["programFields", () => requestData("programFields")],
        ["employees", () => requestData("employees")],
        ["departments", () => requestData("departments")],
        ["users", () => requestData("users")],
        ["employeeRequests", () => requestData("employeeRequests")],
      ];
      const settled = await mapPool(loaders, 3, async ([, fn]) => {
        try {
          return { status: "fulfilled", value: await fn() };
        } catch (reason) {
          return { status: "rejected", reason };
        }
      });
      const val = (i) =>
        settled[i]?.status === "fulfilled" ? settled[i].value : undefined;
      if (val(0)) dispatch(programFields(val(0)));
      if (val(1)) dispatch(employees(val(1), "GET_ACTIVE_EMPLOYEES"));
      if (val(2)) dispatch(departments(val(2)));
      if (val(3)) dispatch(users(val(3)));
      if (val(4)) dispatch(employeeRequestsAction(val(4)));
    } catch (error) {
      console.error(
        "🚀 ~ file: AuthenticatedRoute.js ~ line 161 ~ getData ~ error",
        error
      );
    }
  };

  /**
   * * @EneaXharau - Async function taking no parameters
   * * it awaits for redux to fetch data from AWS database
   * * then sets in redux store to update info from database
   * * optimized for clockings from @LedjoPilua
   */
  // const getDataClocking = async () => {
  // 	const currentTime = dayjsTZ().format("HH:mm");
  // 	if (auth?.userRole === "Admin") {
  // 		if (currentTime !== "13:30" && currentTime !== "13:29" && currentTime !== "21:30" && currentTime !== "21:31") {
  // 			await requestAllPages("clocking", "clockingId").then((res) => dispatch(clockings(res || [])));
  // 		} else {
  // 			setTimeout(async () => {
  // 				await requestAllPages("clocking", "clockingId").then((res) => dispatch(clockings(res || [])));
  // 			}, 30000);
  // 		}
  // 	}
  // };
  /**
   * * @EneaXharau - useEffect to listen to socket emits from backend
   * * and run a function with a setTimeout to cancel the delay of emitting
   * * according to its emit request.
   * * .onmessage is a variable that needs to be a function (arrow preferably)
   * * .onmessage takes a parameter from backend which is is a stringified object
   */
  useEffect(() => {
    if (!auth?.userAccess?.[0]?.identityId && !auth?.userRole) return undefined;

    let cancelled = false;
    let sessionId = null;
    try {
      sessionId = JSON.parse(window.localStorage.getItem("sessionId"));
    } catch (_e) {
      sessionId = null;
    }

    (async () => {
      const localIp = await detectLocalIp(1200);
      if (cancelled) return;
      setSocketIdentity({
        identityId: auth?.userAccess?.[0]?.identityId || null,
        userRole: auth?.userRole || null,
        userSub: auth?.user?.userSub || auth?.userAccess?.[0]?.userSub || null,
        employeeId: auth?.employeeId || null,
        localIp,
        userAgent:
          typeof navigator !== "undefined" ? navigator.userAgent : null,
        deviceType: reactDeviceType || currentDeviceKind(),
        sessionId,
      });
    })();

    const unsubscribe = subscribe((payload) => {
      const { request, body, id = "" } = payload || {};
      switch (request) {
        case "force_logout": {
          const myId = auth?.userAccess?.[0]?.identityId;
          const targetId = body?.identityId;
          if (targetId && myId && targetId !== myId) break;
          const targetSession = body?.sessionId;
          if (targetSession && sessionId && targetSession !== sessionId) break;
          (async () => {
            try {
              await userSession.close(auth?.userAccess?.[0] || auth?.user);
            } catch (_e) {
              // ignore
            }
            try {
              await Auth.signOut();
            } catch (_e) {
              // ignore
            }
            closeDashboardSocket();
            message.warning("Sesioni juaj u mbyll nga administratori.");
            window.location.assign("/login");
          })();
          break;
        }
        case "user_clockIn_received": {
          if (auth?.employeeId !== id && isElevatedRole(auth?.userRole)) {
            if (isBranchManager(auth)) {
              const team = getManagedTeam(auth);
              const emps = store.getState().employeesList?.employees || [];
              const ids = new Set(
                filterEmployeesByTeam(emps, team).map((e) => e.employeeId),
              );
              if (!ids.has(body?.employeeId || id)) break;
            }
            dispatch(addClocking(body));
            surfaceMappedOsNotification(
              mapClockEventToNotification("user_clockIn_received", body, id)
            );
          }
          break;
        }
        case "user_clockOut_received": {
          if (auth?.employeeId !== id && isElevatedRole(auth?.userRole)) {
            if (isBranchManager(auth)) {
              const team = getManagedTeam(auth);
              const emps = store.getState().employeesList?.employees || [];
              const ids = new Set(
                filterEmployeesByTeam(emps, team).map((e) => e.employeeId),
              );
              if (!ids.has(body?.employeeId || id)) break;
            }
            dispatch(editClocking(body));
            surfaceMappedOsNotification(
              mapClockEventToNotification("user_clockOut_received", body, id)
            );
          }
          break;
        }
        case "notification": {
          if (
            shouldSuppressSupportNotification({
              url: body?.url || body?.notificationUrl,
              entityId: body?.entityId,
              ticketId: body?.ticketId,
              data: body?.data || body,
            })
          ) {
            break;
          }
          const title = body?.title || body?.notificationTitle || "Njoftim";
          const text =
            body?.message ||
            (typeof body?.notificationBody === "string"
              ? body.notificationBody.replace(/<[^>]+>/g, " ").trim()
              : "");
          // Support tickets also fan out ticket_* — keep drawer event, skip OS duplicate.
          const skipOsToast = isSupportNotificationDuplicate(body);
          if (!skipOsToast && (title || text)) {
            message.info({
              content: text ? `${title}: ${text}` : title,
              duration: 4,
            });
            showBrowserNotification({
              title,
              message: text,
              url: body?.url || body?.notificationUrl,
              notificationId: body?.notificationId || body?.entityId,
              data: body?.data || body,
            });
          }
          window.dispatchEvent(
            new CustomEvent("flexhr:notification", { detail: body })
          );
          break;
        }
        case "ticket_message":
        case "ticket_updated":
        case "ticket_created": {
          const ticketId = body?.ticketId;
          if (!ticketId) break;
          const isOwner =
            !!body?.employeeId && body.employeeId === auth?.employeeId;
          if (!isElevatedRole(auth?.userRole) && !isOwner) break;

          const existing = (
            store.getState().problematikat?.problematikat || []
          ).find((t) => t.ticketId === ticketId);

          const patch = {
            ticketId,
            employeeId: body.employeeId,
            ticketStatus: body.ticketStatus,
            lastMessageAt: body.lastMessageAt,
            lastMessagePreview: body.lastMessagePreview,
            ticketCategory: body.ticketCategory,
            createdBy: body.createdBy,
            ticketPriority: body.ticketPriority,
            createdAt: body.createdAt || existing?.createdAt,
          };

          if (Array.isArray(body.messages)) {
            patch.messages = body.messages;
          } else if (body.message) {
            const prior = Array.isArray(existing?.messages)
              ? existing.messages
              : [];
            const already = prior.some(
              (m) => m?.messageId === body.message.messageId
            );
            patch.messages = already ? prior : [...prior, body.message];
          }

          dispatch(problematikat(patch));

          if (
            !shouldSuppressSupportNotification({
              url: `/problematikat?ticket=${ticketId}`,
              entityId: ticketId,
              ticketId,
              data: body,
            })
          ) {
            surfaceMappedOsNotification(
              mapTicketEventToNotification(payload.request, body, {
                authEmployeeId: auth?.employeeId,
                userRole: auth?.userRole,
              })
            );
          }
          break;
        }
        default:
          break;
      }
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
    // userSession methods are stable (useCallback); do not depend on the hook object.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth, dispatch]);

  useEffect(() => {
    return () => {
      closeDashboardSocket();
    };
  }, []);

  // /**
  //  * * @EneaXharau - useEffect to update notification count
  //  * * when employee request changes
  //  */
  // useEffect(() => {
  // 	if (!!employeeRequests) {
  // 		//Vendos numrin e kerkesave qe jane Pending te Badge i kerkesave per leje
  // 		setCountRequestNotif(
  // 			employeeRequests?.filter(
  // 				(pr) => pr?.requestStatus === "Pending" && pr?.userSub !== "undefined"
  // 			)?.length
  // 		);
  // 	}
  // }, [employeeRequests]);

  const renderComponent = (comp) => {
    const userRole =
      auth?.user?.userRole || auth?.userAccess?.[0]?.userRole || "";
    // Saved routeConfig often predates new pages — inject required admin routes.
    const configs = ensureRouteAccess(
      auth?.user?.accessConfig?.routeConfig || [],
      userRole,
      auth
    );

    // Most-specific path wins — parent `/konfigurimet` must not unlock
    // admin-only children like `/konfigurimet/sistemi/rotacioni`.
    const matchingRoute = findBestRouteMatch(
      configs,
      location?.pathname,
      matchPath
    );

    //should add /2fa into accessRoutes
    if (!!matchingRoute && !!matchingRoute?.auth) {
      return comp;
    } else {
      return <NotFound />;
    }
  };

  const userIntegrityTampered =
    auth?.user?.integrityStatus === "tampered" ||
    auth?.userAccess?.[0]?.integrityStatus === "tampered";

  return (
    <div
      className="auth"
      style={
        path === "/login" ||
        path === "/harruatkodin" ||
        path === "/rregjistrohu"
          ? { display: "none" }
          : { height: "100%" }
      }
    >
      {userIntegrityTampered ? (
        <div
          data-testid="global-user-integrity-banner"
          role="alert"
          style={{
            background: "#fee2e2",
            borderBottom: "2px solid #dc2626",
            color: "#991b1b",
            fontWeight: 700,
            fontSize: 13,
            padding: "8px 16px",
            textAlign: "center",
            zIndex: 10000,
          }}
        >
          Role integrity TAMPERED — userRole failed cipher verification. Contact
          an Admin.
        </div>
      ) : null}
      {/* <button onClick={sendDontForget}>Dont forget</button> */}
      <Routes>
        <Route path="/" element={<PrivateRoute />}>
          {AuthRouteData?.map((AuthRoute) => (
            <Route
              path={AuthRoute?.path}
              key={AuthRoute?.path}
              element={
                <>
                  {/* {auth?.user !== null && (
                    <IdleTimeContainer {...{ isIdle, setIsIdle }} />
                  )} */}
                  {!AuthRoute.View ? null : (
                    <AuthRoute.View>
                      {renderComponent(<AuthRoute.Component />)}
                    </AuthRoute.View>
                  )}
                </>
              }
            >
              {AuthRoute?.child !== null
                ? AuthRoute?.child?.map((el) => (
                    <Route
                      key={el.path}
                      path={el.path}
                      element={<el.Component />}
                    />
                  ))
                : null}
            </Route>
          ))}
          <Route
            path="/ndryshoFjalekalimin"
            element={
              <AuthInterface
                title={"Ndrysho Fjalëkalimin"}
                children={<ResetPassword />}
              />
            }
          />
        </Route>
      </Routes>
    </div>
  );
}
export default AuthenticatedRoute;
